module.exports = __webpack_public_path__ + "static/media/graphique_comportement.376ccfc8.gif";